export const YCFTermsOfServiceData = [{
    header: "",
    content: 
            <div>
                <b>Last Updated:</b> May 12, 2026
            </div>
}, {
    header: "",
    content: 
            <div>
                Welcome to the <b>YouTube Comment Filter</b>. By using our extension, you agree to these Terms & Conditions. If you have any concerns, we recommend reviewing them before continuing to use our platform.
            </div>
}, {
    header: "Acceptance of Terms",
    content: 
            <div>
                By accessing or using the <b>YouTube Comment Filter</b>, you acknowledge that you have read, understood, and agree to be bound by these terms. We reserve the right to update these terms at any time without prior notice. Your continued use of the service constitutes acceptance of any modifications.
            </div>
}, {
    header: "Use of YouTube Comment Filter Extension",
    content: 
            <>
                <div>This extension complies with Chrome Web Store policies including user data handling and usage restrictions.</div><br/>
                <div>By using the YouTube Comment Filter Chrome extension:</div><br/>
                <ul>
                    <li>You agree that the extension processes publicly available YouTube data (comment text, video title, and description) for the purpose of filtering comments.</li>
                    <li>You acknowledge that the extension uses Google Login solely to manage your usage limits and identify your account.</li>
                    <li>You agree not to misuse the extension for scraping or unauthorized data collection beyond its intended functionality.</li>
                    <li>You agree to use this extension only for filtering and exporting comments for personal use, not for bulk scraping or automated data collection.</li>
                    <li>The extension offers a free tier with limited credits. Upgrading to premium unlocks higher usage limits.</li>
                </ul><br/>
                <div>A 'Lifetime' plan refers to the lifetime of the YouTube Comment Filter product. This means you have access for as long as the extension is actively maintained and commercially available by us, not for the lifetime of the buyer.</div><br/>
                <div>The extension relies on YouTube's current website structure. We are not liable if updates or changes made by YouTube render the extension partially or fully non-functional. We will make reasonable efforts to update the tool, but cannot guarantee permanent compatibility.</div>
            </>
}, {
    header: "Fair Usage & Misuse Policy",
    content: 
            <ul>
                <li>
                    Users are expected to follow fair usage. Excessive or abnormal usage patterns may lead to account review.
                </li>
                <li>
                    Abuse, harassment, or threatening behavior toward the platform or support team is strictly prohibited.
                </li>
                <li>
                    Spamming, automated/bot access, or attempts to overload the system are considered misuse.
                </li>
                <li>
                    Reverse-engineering, tampering with the code, or any disruptive actions are forbidden.
                </li>
                <li>
                    Initiating chargebacks without first contacting support is treated as abuse.
                </li>
                <li>
                    We reserve the right to take appropriate action, including blocking access or reporting misconduct.
                </li>
            </ul>
}, {
    header: "Pricing & Feature Changes",
    content: 
            <div>
                We reserve the right to modify our pricing plans, usage limits, and feature availability at any time without prior notice. Continued use of the service constitutes acceptance of these changes.
            </div>
},  {
    header: "Limitation of Liability",
    content: 
            <>
                <ul>
                    <li>
                        We provide the service <b>"as is" without warranties of any kind</b>.
                    </li>
                    <li>
                        We are <b>not responsible for any data loss, errors, or inaccuracies</b> resulting from using our service.
                    </li>
                    <li>
                        We <b>reserve the right to modify, suspend, or discontinue</b> any part of the service at any time.
                    </li>
                </ul>
            </>
}, {
    header: "Indemnification",
    content: 
            <div>
                By using this service, you agree to <b>indemnify and hold us harmless</b> from any claims, damages, or losses arising from your use of the platform.
            </div>
}, {
    header: "Governing Law",
    content: 
            <ul>
                <li>
                    These Terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in India.
                </li>
                <li>
                    We <b>operate under Indian law</b>. Users outside India are responsible for ensuring compliance with their local data regulations.
                </li>
                <li>
                    If you access this service from outside India, you do so at your own discretion and are responsible for ensuring    compliance with your local laws.
                </li>
            </ul>
}, {
    header: "Refund Policy for 'YouTube Comment Filter'",
    content: 
            <div>
                We offer a 30-day refund policy for premium plans. If you're not satisfied with the service, you may request a full refund within 30 days of your purchase - no questions asked.
                To request a refund, contact us at: 📧 <span className="emailId">support@easyimagetotext.com</span>
            </div>
}, {
    header: "Changes to Terms",
    content: 
            <div>
                We may update these terms at any time. Any changes will be reflected on this page with the updated date. Continued use of the service after changes constitutes acceptance of the new terms.
            </div>
}, 
{
    header: <div><span style={{textDecoration: 'underline'}}>Legal Entity & Contact Information</span></div>,
    content:
            <div>
                <div className="mt-10"><b>Company Name:</b> Easy Image to Text (Government of India Registered Micro Enterprise)</div>
                <div className="mt-10"><b>Official Address:</b> Flat 2C, Daffodils Apartments, Block 63, Velachery Main Road, Rajakilpakkam, Chennai, Tamil Nadu - 600073, India.</div>
                <div className="mt-10"><b>Email:</b> support@easyimagetotext.com</div>
            </div>
}, 
{
    header: "Contact Us",
    content: 
            <div>
                For any questions regarding these Terms & Conditions, please contact us at: 📧 <span className="emailId">support@easyimagetotext.com</span>
            </div>
}, {
    header: "",
    content: 
            <div>
                By using the <b>YouTube Comment Filter</b>, you agree to these Terms and Conditions.
            </div>
}]